import { Typography } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import classNames from 'classnames'
import * as React from 'react'
import { styles } from './styles'

type ButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'onClick'
> & {
  onClick: () => void
  icon?: string
  label: string | React.ReactNode
  onSubmit?: () => void
  isSubmitting?: boolean
  disabled?: boolean
  customStyle?: string
  customTextStyle?: string
  hoverEffects?: boolean
}

const CHRButton = ({
  onClick,
  icon,
  label,
  isSubmitting,
  disabled,
  customStyle,
  customTextStyle,
  hoverEffects,
  type = 'button',
  className,
  ...props
}: ButtonProps) => {
  const classes = styles()
  const buttonClass = classNames(
    {
      [classes.container]: true,
      [classes.hoverEffect]: hoverEffects,
      [classes.disabled]: disabled,
    },
    customStyle,
    className
  )
  return (
    <button
      type={type}
      className={buttonClass}
      onClick={() => onClick()}
      disabled={disabled}
      {...props}
    >
      {icon && <img src={icon} className={classes.icon} alt="" />}
      {isSubmitting ? (
        <CircularProgress color="secondary" size={20} />
      ) : (
        <Typography variant="button" component="p" className={customTextStyle}>
          {label}
        </Typography>
      )}
    </button>
  )
}

export default CHRButton
